module.exports = __webpack_public_path__ + "img/category-skill-game-hover1.6ca16d8f.png";